import { Box, Group, Heading, Text } from '@optiaxiom/react';
import { IconCheckCircleSolid, IconShieldCheck } from '@optiaxiom/icons';
import styles from './ApiKeyActiveState.module.css';

const PRACTICES = [
  "Don't share your API key with anyone.",
  "Don't commit your API key to public repositories.",
  'Use environment variables when possible.',
  'Rotate your key if you suspect it has been compromised.',
];

export function SecurityBestPractices() {
  return (
    <Box bg="bg.default" className={styles.card}>
      <Group flexDirection="row" alignItems="center" gap="8" mb="16">
        <Box color="fg.secondary">
          <IconShieldCheck />
        </Box>
        <Heading level="2" fontWeight="700">
          Security best practices
        </Heading>
      </Group>

      <Box asChild className={styles.practices}>
        <ul>
          {PRACTICES.map((practice) => (
            <li key={practice} className={styles.practice}>
              <Box color="fg.success">
                <IconCheckCircleSolid />
              </Box>
              <Text>{practice}</Text>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  );
}
